'use strict';

/* global Modernizr */

const _ = require('lodash');

function ProcessingJobsController (
      $scope, $rootScope, $state, $window, $http, $timeout, SaturnGrowl,
      NgTableParams, OrgProjects, ManagerService, ManagerStore, IdentityService,
      AnalyticsService, PlanStore
  ) {

  const uploaderSite = IdentityService.get('uploadUrl');
  let uploaderToken = '';

  const vm = this;

  vm.org = IdentityService.getCurrentOrganization();

  vm.activeJobUuid = _.get($state, ['params', 'job']);
  vm.queryPage = parseInt(_.get($state, ['params', 'page']));
  vm.currentGlobalPage = (vm.queryPage > 0) ? vm.queryPage : 1;
  vm.globalSearchTerm = vm.querySearch = _.get($state, ['params', 'search']);
  vm.globalSort = vm.querySort = _.get($state, ['params', 'sort']);
  vm.hasEnabledPlan = PlanStore.get('orgPlan') && PlanStore.get('orgPlan').isEnabled;
  vm.isIngestorUser = IdentityService.isIngestBetaUser();

  vm.modernizrAvailable = typeof Modernizr !== 'undefined';
  let deviceAgent = navigator.userAgent.toLowerCase();
  // TODO: refactor this to be cleaner and remove redundancy. we don't need to support Bada either.
  vm.modernizrTouch = Modernizr.touch && (deviceAgent.match(/(iphone|ipod|ipad)/) || deviceAgent.match(/(android)/) || deviceAgent.match(/(iemobile)/) || deviceAgent.match(/iphone/i) || deviceAgent.match(/ipad/i) || deviceAgent.match(/ipod/i) || deviceAgent.match(/blackberry/i) || deviceAgent.match(/bada/i));

  vm.state = 'overview';

  // Global pagination
  vm.itemsPerPage = 10;

  vm.globalFilter = '';
  vm.globalSort = ['name'];
  vm.localSortType = '-updatedAt';

  vm.showSiteLoader = false;

  vm.accordionStates = {};

  vm.toggleAccordion = (id) => {

    vm.accordionStates[id] = !vm.accordionStates[id];
  };

  vm.getAccordionState = (id) => {

    return vm.accordionStates[id];
  };

  vm.expandAccordions = () => {

    vm.expandAll = true;
  };

  vm.collapseAccordions = () => {

    vm.accordionStates = {};
    vm.expandAll = false;
  };

  vm.tables = [];

  vm.reverse = false;

  vm.setCounts = (jobsRef) => {

    let obj = {};
    ManagerService.PROCESSING_STATES.forEach((state) => {
      obj = _.extend(obj, {
        [state]: 0
      });
    });
    jobsRef.forEach((job) => {
      obj[job.state]++;
    });
    return obj;
  };

  vm.init = () => {

    vm.formatProjectData();
  };

  // This method gets the project data and formats it so
  vm.formatProjectData = () => {

    let projects = [];
    if (ManagerStore.get('projects')) {
      projects = ManagerStore.get('projects');
    }
    else {
      projects = OrgProjects;
    }

    // For the visible projects on the page set up the processing jobs tables
    for (let tableIndex = 0; tableIndex < projects.length; ++tableIndex) {

      let project = projects[tableIndex];
      if (!project) {
        continue;
      }

      // Make faster by only doing this on the objects in the view. look into ng-repeat pagination
      if (!project.parsedJobs) {
        const captures = project.sites[0].dataCaptures;
        project.parsedJobs = [];
        captures.forEach((capture) => {
          if (capture.processingJob.uuid) {
            const job = ManagerService.makeNiceJobData(capture.processingJob, project, capture);
            project.parsedJobs.push(job);
          }
          else {
            // This shouldn't be happening anymore due to API filtering
            console.warn('Grandfather DataCapture. Omitted Reason: [No ProcessingJobId associated with DataCapture]');
          }
        });
        project.currentLocalPage = 1;
        project.summary = vm.setCounts(project.parsedJobs);

        // Create a new table for this project
        // Only store vm.itemsPerPage at a time [memory]
        vm.tables[tableIndex] = _.clone(project.parsedJobs);
      }
      else {
        if (project.parsedJobs) {
          vm.tables[tableIndex] = project.parsedJobs;
        }
      }
    }

    // Assign a clone of the projects object to force a reload on the render
    vm.projects = _.clone(projects);
    ManagerStore.$set('projects', _.clone(vm.projects));
  };

  vm.onGlobalPageChange = (newPage, oldPage) => {

    $state.go('.', { page: newPage }, { notify: false });
    vm.init();
  };

  // vm.onLocalPageChange = (newPage, oldPage) => {
  //
  //   // Maybe animate it when we have serverside pagination
  // };

  // Set up search/filter
  vm.applyGlobalSearch = () => {

    let term = vm.globalSearchTerm;
    if (vm.isInvertedSearch) {
      term = '!' + term;
    }
    vm.globalFilter = term;
  };

  vm.goToJob = ($event, job) => {

    $event.stopPropagation();
    if (job.state === 'Completed') {
      vm.showSiteLoader = job.id;
      $state.go('dash.map', {
        siteName: job.slug,
        dataCaptureId: job.captureId
      });
    }
  };

  /**======     Sorting    ======**/
  /**------      Global    -----**/
  vm.globalSortOptions = [
    {
      type: 'name',
      descriptor: 'A-Z',
      direction: 'desc'
    },
    {
      type: '-name',
      descriptor: 'Z-A',
      direction: 'asc'
    },
    {
      type: '-createdAt',
      descriptor: 'Most Recent',
      direction: 'desc'
    },
    {
      type: 'createdAt',
      descriptor: 'Least Recent',
      direction: 'asc'
    }
  ];

  vm.applyGlobalSort = (sort) => {

    if (sort) {
      vm.globalSort = sort[0].type;
    }
    else {
      vm.selectedGlobalSort = vm.globalSortOptions[0];
      vm.globalSort = vm.selectedGlobalSort.type;
    }
    $state.go('.', { sort: vm.globalSort }, { notify: false });
  };

  /**------      Local    -----**/
  vm.localSortOptions = [
    {
      type: '-capturedAtTime',
      descriptor: 'Most Recent Capture Date',
      direction: 'desc'
    },
    {
      type: 'capturedAtTime',
      descriptor: 'Least Recent Capture Date',
      direction: 'asc'
    },
    {
      type: 'state',
      descriptor: 'Status A-Z',
      direction: 'desc'
    },
    {
      type: '-state',
      descriptor: 'Status Z-A',
      direction: 'asc'
    },
    {
      type: '-updatedAt',
      descriptor: 'Most Recently Updated',
      direction: 'desc'
    },
    {
      type: 'updatedAt',
      descriptor: 'Least Recently Updated',
      direction: 'asc'
    },
    {
      type: '-createdAt',
      descriptor: 'Most Recently Created',
      direction: 'desc'
    },
    {
      type: 'createdAt',
      descriptor: 'Least Recently Created',
      direction: 'asc'
    }
  ];

  vm.toggleLocalSort = (string) => {

    let key = string;
    if (key === vm.localSortType) {
      if (key.charAt(0) === '-') {
        key = key.slice(1);
      }
      else {
        key = '-'.concat(key);
      }
    }
    else {
      key = string;
    }

    const option = _.find(vm.localSortOptions, (option) => {
      return option.type === key;
    });
    vm.localSort = [option];
    vm.localSortType = vm.localSort[0].type;
  };
  /**======     End Sorting    ======**/

  vm.viewJob = (id) => {

    vm.showSpinner = true;
    $state.go(ManagerService.JOB_DETAIL_STATE, {
      job: id
    });
    vm.state = 'detailed';
  };

  vm.updateUploaderUrl = () => {

    const url = IdentityService.getAuthApiUri() + '/sso';

    const httpConfig = {
      url,
      method: 'POST'
    };

    return $http(httpConfig)
      .then((payload) => {

        const data = payload.data.data;
        uploaderToken = data.token;
      })
      .catch((payload, status) => {
        console.warn('SSO fetch failed', payload, status);
      });
  };

  vm.toggleUploader = _.debounce(() => {

    if (vm.isIngestorUser) {
      $state.go('uploader')
    }
    else {
      let url;

      if (uploaderToken) {
        url = uploaderSite + 'login?token=' + uploaderToken + '&orgId=' + IdentityService.get('currentOrganization').id;
      }
      else {
        url = uploaderSite;
      }
      $window.open(url, '_blank');
    }    
  }, 0);

  // init
  this.updateUploaderUrl();

  /**======     Event Listeners    ======**/
  $rootScope.$on('$stateChangeStart', (event, toState, toParams) => {

    // ensure that this controller always recognizes when the detailed view is open, even on page refresh
    if (toParams.job) {
      vm.state = 'detailed';
    }
    vm.activeJobUuid = toParams.job;
  });

  $scope.$watch('vm.globalSearchTerm', () => {

    vm.applyGlobalSearch();
  });

  vm._handleJobsChanged = () => {

    if (this.projects) {
      for (let project of this.projects) {
        delete project.parsedJobs;
      }
    }
    vm.formatProjectData();
  };

  vm._handleOpenDetailView = () => {

    vm.state = 'detailed';
    vm.showSpinner = false;
  };

  vm._handleCloseDetailView = () => {

    vm.state = 'overview';
    vm.activeJobUuid = null;
  };

  vm._handleDeletedJob = () => {

    vm._handleJobsChanged();
  };

  vm._handleCreatedJob = (data) => {

    vm._handleJobsChanged();
    SaturnGrowl.newGrowl('A new dataset has been sent to processing. We will notify you when it is completed.', {
      type: 'success',
      time: 3500,
      id: 'processing',
      cta: {
        callback: function() {
          $state.go('manager.processingJobs.job', { job: data.job.uuid });
        }
      }
    });
  };

  vm._handleManagerStoreDeletedProject = (deletedProject) => {

    vm.formatProjectData();

    if ($state.is('manager.processingJobs.job')) {
      if (_.find(deletedProject.parsedJobs, 'uuid', vm.activeJobUuid)) {
        $state.go('manager.processingJobs');
      }
    }
  };

  $rootScope.$on('$stateChangeStart', (evt, toState, toParams, fromState, fromParams) => {

    if (toState.name === 'dash.map' && fromState.name === 'manager.processingJobs.job') {
      const job = ManagerStore.getJob(fromParams.job);
      if (job && job.value) {
        vm.showSiteLoader = job.value.id;
        if (job.value.site) {
          vm.accordionStates[job.value.site.project.id] = true;
        }
      }
    }
  });

  vm.init();
  vm.updateUploaderUrl();
  if (vm.querySort) {
    const sort = _.find(vm.globalSortOptions, 'type', vm.querySort);
    if (sort) {
      vm.selectedGlobalSort = [sort];
      vm.applyGlobalSort([sort]);
    }
  }

  ManagerStore.on(ManagerStore.Events.CloseDetailView, this._handleCloseDetailView.bind(this), $scope);
  ManagerStore.on(ManagerStore.Events.OpenDetailView, this._handleOpenDetailView.bind(this), $scope);
  ManagerStore.on(ManagerStore.Events.Updated, this.init.bind(this), $scope);
  ManagerStore.on(ManagerStore.Events.ProcessingJobDestroyed, this._handleDeletedJob.bind(this), $scope);
  ManagerStore.on(ManagerStore.Events.Created, this._handleCreatedJob.bind(this), $scope);
  ManagerStore.on(ManagerStore.Events.DeletedProject, vm._handleManagerStoreDeletedProject.bind(vm));
}

ProcessingJobsController.$inject = [
  '$scope', '$rootScope', '$state', '$window', '$http', '$timeout', 'SaturnGrowl',
  'NgTableParams', 'OrgProjects', 'ManagerService', 'ManagerStore', 'IdentityService',
  'AnalyticsService', 'PlanStore'
];

module.exports = ProcessingJobsController;



// WEBPACK FOOTER //
// ./src/app/manager/processing/ProcessingJobsController.js